import { render } from "./ClockComponent.vue?vue&type=template&id=98dea9c0"
import script from "./ClockComponent.vue?vue&type=script&lang=js"
export * from "./ClockComponent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__